var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.params.value == 0)?_c('div',[_vm._v("0")]):_c('div',{staticClass:"text-blue-500 underline cursor-pointer",on:{"click":function($event){return _vm.showOnOrder()}}},[_vm._v(" "+_vm._s(_vm.params.value)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }